<template>
  <div
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
  >
    <el-table v-if="getUserType === 'observer'"
      :data="patientsTableDataForSafe"
      class="table_wrapper"
      style="width: 95%"
    >
      <el-table-column sortable width="180">
        <template slot="header">
          <Header label="PROCEDURE DATE" subLabel="(Patient Tag)" />
        </template>
        <template slot-scope="scope">
          <TagFormatter :row="scope.row.procedureDate" />
        </template>
      </el-table-column>

      <el-table-column width="180">
        <template slot="header">
          <Header label="PATIENT ID" subLabel="(Last Activity)" />
        </template>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.patient" />
        </template>
      </el-table-column>

      <el-table-column label="NEXT EVENT" width="180" sortable>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.nextEvent" />
        </template>
      </el-table-column>

      <el-table-column prop="site" label="SITE" width="180"> </el-table-column>

      <el-table-column width="180">
        <template slot="header">
          <Header label="#SURVEYS" subLabel="(Answered by doctors)" />
        </template>
        <template slot-scope="scope">
          <FlagFormatter :row="scope.row.surveys" />
        </template>
      </el-table-column>

      <el-table-column width="180">
        <template slot="header">
          <Header label="#Q'NAIRES" subLabel="(Answered by patients)" />
        </template>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.qnairs" />
        </template>
      </el-table-column>

      <el-table-column label="#FILES" width="100">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.files" />
        </template>
      </el-table-column>

      <el-table-column label="#RECORDS" width="100">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.records" />
        </template>
      </el-table-column>
    </el-table>



    <el-table v-else
      :data="patientsTableDataForProvider"
      class="table_wrapper"
      style="width: 95%"
    >
      <el-table-column width="300">
        <template slot="header">
          <Header label="PATIENT NAME" subLabel="(Last Active)" />
        </template>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.patient" />
        </template>
      </el-table-column>

      <el-table-column label="FACE SHEET" width="150">
        <template slot-scope="scope">
          <img src="../icons/facesheet.svg" @click="navigateToLink(scope.row)" />
        </template>
      </el-table-column>

      <el-table-column label="UPCOMING EVENT" v-if="dataType === 'patient'" width="250" sortable>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.nextEvent" />
        </template>
      </el-table-column>

      <el-table-column width="200" v-if="dataType === 'patient'">
        <template slot="header">
          <Header label="QUESTIONNAIRES" subLabel="" />
        </template>
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.qnairs" />
        </template>
      </el-table-column>

      <el-table-column label="CARE SHARE PHASE" width="200" v-if="dataType === 'patient'">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.site" />
        </template>
      </el-table-column>

      <el-table-column label="#FILES" width="180" v-if="dataType === 'doctor'">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.files" />
        </template>
      </el-table-column>

      <el-table-column label="#RECORDS" width="180" v-if="dataType === 'doctor'">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.records" />
        </template>
      </el-table-column>

      <el-table-column width="220" v-if="dataType === 'doctor'">
        <template slot="header">
          <Header label="SURVEYS ANSWERED" subLabel="" />
        </template>
        <template slot-scope="scope">
          <FlagFormatter :row="scope.row.surveys" />
        </template>
      </el-table-column>

      <el-table-column label="PROVIDER" width="150">
        <template slot-scope="scope">
          <SubHeadingFormatter :row="scope.row.site" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import TagFormatter from "./Formatters/TagFormatter.vue";
import SubHeadingFormatter from "./Formatters/SubHeadingFormatter.vue";
import FlagFormatter from "./Formatters/FlagFormatter.vue";
import Header from "./Formatters/Header.vue";
import facesheetIcon from "../icons/facesheet.svg";

export default {
  props: ["dataType"],
  computed: {
    ...mapGetters(["getUserType"]),
    ...mapState("provider", ["providerPatients", "nextPatients"]),
    ...mapGetters("provider", ["getProvidersIdArray", "getCurrentProvider"]),
    ...mapGetters("overview", ["patientsTableDataForSafe", "patientsTableDataForProvider"]),
  },
  components: {
    TagFormatter,
    SubHeadingFormatter,
    FlagFormatter,
    Header,
    facesheetIcon
  },
  watch: {
    providerPatients: {
      immediate: true,
      handler(val) {
        if (val) {
          this.changePatientTableData(val);
        }
      },
    },
  },
  methods: {
    ...mapActions("overview", ["changePatientTableData"]),
    ...mapActions("provider", ["loadProviderPatients"]),
    navigateToLink(row) {
      console.log('ROWW', row)
      if (row.facesheet) {
        this.$router.push({ path: row.facesheet });
      }
    },
    loadMore() {
      let providerList = this.getProvidersIdArray;
      if (this.getCurrentProvider) providerList = [this.getCurrentProvider];
      if (this.nextPatients[providerList[0]] !== true) {
        Promise.all(
          providerList.map((provider) => {
            const next = this.nextPatients[provider]
            return this.loadProviderPatients({
              id: provider,
              next,
            });
          })
        );
      }
    },
  },
};
</script>

<style>
.table_wrapper {
  margin: 10px auto;
  border-radius: 12px;
  padding: 15px;
}
.cell {
  display: flex !important;
  align-items: center;
}
</style>
